//#region  imports
import React, { useMemo, useRef, useState } from "react";
import { useScreenSize } from "../../../utils/media-query.js";
import BaseFormWithBreadCrumbs from "../../../components/base-form/base-form.js";
import Form, { GroupItem, Item, Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import { useDataSource } from "../../../contexts/dataSource.js";
import { useAuth } from "../../../contexts/auth.js";
import { getSelectBoxPropertiesIdText } from "../../../utils/default-props.js";
import { useParams } from "react-router-dom";
import { getPropsDateEdit } from "../../../utils/default-props.js";

//#endregion

function SalaryAdvanceCard() {
    //#region hooks
    const params = useParams()
    const { user } = useAuth()
    const { dataSourceHR } = useDataSource()
    const screenSize = useScreenSize()
    const formRef = useRef()
    //#endregion

    //#region states
    const [formData, setFormData] = useState({
        employeeId: "",
        requestDate: "",
        voucherNumber: "",
        purpose: "",
        requestAmount: 0,
        isInstallmentRequested: false,
        numberOfInstallments: 0,
        approvalStatus: false,
        approvalDate: ""
    })
    const [readOnly, setReadOnly] = useState(false)
    const [dirty, setDirty] = useState(false)
    const [id, setId] = useState(params.id)
    const [dataLoading, setDataLoading] = useState(false)
    //#endregion

    const dbEmployes = useMemo(() => dataSourceHR({
        loadUrl: `/api/Employee/ComboList`,
        loadMode: "raw",

    }), [user])

    //#region handle events
    const handleFieldDataChanged = (e) => {
        setDirty(true)
    }

    // const onAfterSave = () => {
        // if (refreshGrid)
        //     refreshGrid()
    // }

    //#endregion

    //#region editorOptions
    const employeEditorOptions = {
        dataSource: dbEmployes,
        ...getSelectBoxPropertiesIdText
    }

    //#endregion

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>

                    <BaseFormWithBreadCrumbs
                        formData={formData}
                        setFormData={setFormData}
                        formRef={formRef}
                        readOnly={readOnly}
                        setReadOnly={setReadOnly}
                        dirty={dirty}
                        setDirty={setDirty}
                        loadId={id}
                        loadUrl={"/api/EmployeeAdvance/"}
                        updateUrl={"/api/EmployeeAdvance/FormData"}
                        // onAfterSave={onAfterSave}
                        dataLoading={dataLoading}
                        setDataLoading={setDataLoading}
                    >
                        <Form
                            labelLocation={screenSize.isXSmall ? "top" : "left"}
                            formData={formData}
                            readOnly={readOnly}
                            onFieldDataChanged={handleFieldDataChanged}
                            ref={formRef}
                            width={500}
                        >
                            <GroupItem caption="Maaş Avansı Kayıt İşlemi">
                                <SimpleItem
                                    dataField="employeeId"
                                    editorType="dxSelectBox"
                                    editorOptions={employeEditorOptions}>
                                    <Label text="Personel" />
                                    <RequiredRule />
                                </SimpleItem>

                                <Item dataField="requestDate"
                                    editorType="dxDateBox"
                                    editorOptions={getPropsDateEdit}
                                    name="requestDate"
                                >
                                    <Label text="Talep Tarihi" />
                                    <RequiredRule />
                                </Item>

                                <SimpleItem dataField="voucherNumber">
                                    <Label text="Fiş Numarası" />
                                    <RequiredRule />
                                </SimpleItem>

                                <SimpleItem dataField="purpose">
                                    <Label text="Talep Sebebi" />
                                    <RequiredRule />
                                </SimpleItem>

                                <SimpleItem dataField="requestAmount" editorType="dxNumberBox">
                                    <Label text="Avans Miktarı" />
                                    <RequiredRule />
                                </SimpleItem>

                                <SimpleItem dataField="isInstallmentRequested">
                                    <Label text="Taksit Durumu" />
                                </SimpleItem>

                                <SimpleItem dataField="numberOfInstallments"
                                    editorType="dxNumberBox"
                                >
                                    <Label text="Taksit Adedi" />
                                    <RequiredRule />
                                </SimpleItem>

                            </GroupItem>

                        </Form>
                    </BaseFormWithBreadCrumbs>

                </div>
            </div>

        </React.Fragment >
    )
}

export default SalaryAdvanceCard